/**
 * Issue #899 (supersedes D148's stopgap; #881's earlier filing of the same
 * follow-up) — `?edit=<matchId>` asks `/performance` to open that match's
 * OWN edit form directly, the one-tap deep link the season record's pencil
 * (and the one-match record's, issue #900) always meant to reach.
 *
 * Same "read once, strip immediately" contract `activityCreate.js`'s
 * `?new=1` already established (see that file's own header): the id is
 * captured into state on the mount the deep link caused, and the param is
 * gone from the address bar before the match list has even answered, so a
 * bookmarked/shared URL never re-opens a stale edit. A separate module
 * from `activityCreate.js` rather than a fourth `OPTIONS` entry there —
 * that table is "where a FRESH create lands", one per activity kind; this
 * is "which EXISTING row to open", a different question with a different
 * shape (an id, not a role-filtered destination list).
 */

/** The query param `?edit=<matchId>` is read from. */
export const EDIT_PARAM = "edit";

/**
 * The match id `?edit=` names, or `null` when absent/blank. Never coerced
 * to a number — `match_id` rides through the app as whatever the API sends
 * (a UUID on some deployments, an integer on others; `MatchRow.jsx`'s own
 * `data-testid={`match-card-${m.match_id}`}` already treats it as opaque),
 * so this stays a string comparison end to end.
 *
 * @param {string|URLSearchParams} search
 * @returns {string|null}
 */
export function editMatchId(search) {
  const params = typeof search === "string" ? new URLSearchParams(search) : search;
  const id = params?.get(EDIT_PARAM);
  return id && id.trim() !== "" ? id : null;
}

/** `/performance?edit=<matchId>` — the pencil's own one-tap deep link. */
export function withEditMatch(matchId) {
  return `/performance?${EDIT_PARAM}=${encodeURIComponent(matchId)}`;
}
